import {CircularProgress, Grid, Typography, withStyles} from 'material-ui'
import Title from './title'
import Subtitle from './subtitle'
import {
  CardCVCInput,
  CardExpiryInput,
  CardholderNameInput,
  CardNumberInput,
  DocumentNumberInput,
  DocumentTypeSelector,
} from '../../../common/components/CreditCardInput'
import Button from '../../../components/button'
import React, {Fragment} from 'react'
import {getDocTypeByID} from './AddCreditCard'
import {docTypesData} from '../constants'

const styles = theme => ({
  container: {
    minHeight: 550,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  content: {
    maxWidth: 530,
    width: '100%',
    margin: 'auto',
    padding: '5px 0',
    '@media (min-width: 960px)': {
      maxWidth: 'none',
    },
  },
  titleContainer: {
    marginBottom: 20,
  },
  noteContainer: {
    padding: 10,
    marginTop: 5,
    boxShadow: theme.shadows[2],
  },
  navigator: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 'auto',
  },
  input: {
    width: '100%',
    margin: '5px 0',
  },
  bottomContainer: {
    marginTop: 0,
    marginBottom: 7,
  },
  noCardContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  noCard: {
    marginTop: 5,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  termsContainer: {
    textAlign: 'center',
  },
  link: {
    color: theme.palette.primary.main + '!important',
  },
  mpContainer: {
    textAlign: 'center',
  },
  mp: {
    marginTop: 5,
    marginLeft: 10,
  },
  padlock: {
    position: 'absolute',
    right: 30,
    top: 30,
    alignItems: 'center',
    flexDirection: 'column',
    display: 'none',
    '@media (min-width: 960px)': {
      display: 'flex',
    },
  },
  padlockImage: {
    height: 48,
    width: 48,
    objectFit: 'contain',
  },
  mpLabel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '0.8em',
  },
  fullWidth: {width: '100%'},
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

const CreditCardForm = ({classes, loadingCard, loadingDeposit, documentType, documentNumber, ...props}) => {
  const options = docTypesData.map(({id, name}) => ({value: id, label: name}))

  const onNumberChange = (v, e, t) => {
    if (!e) {
      props.setCardNumber(v)
      props.setCardType(t)
    }
  }

  const onExpiryChange = (m, y) => {
    props.setCardExpiry(m + ' / ' + y)
  }

  const onBuy = async () => {
    const successSaveCard = await props.saveCard()
    if (successSaveCard) {
      const successSaveDeposit = await props.saveDeposit()
    }
  }

  const isDocNumberInvalid = () => {
    const docType = getDocTypeByID(documentType)
    return documentNumber !== '' &&
      (
        parseInt(documentNumber, 10) <= 0
        || documentNumber.length < docType.min_length
        || documentNumber.length > docType.max_length
      )
  }

  return (
    <Fragment>
      <div className={classes.padlock}>
        <img src="/assets/padlock.jpg" alt="mercado pago" width={100} className={classes.padlockImage}/>
        <Typography variant={'caption'}>SITIO SEGURO</Typography>
      </div>
      <div className={classes.titleContainer}>
        <Title>Por favor, ingresá los datos de tu tarjeta de crédito para reservar tu guardado</Title>
        <Typography variant='body1' align='center'>
          Para validar tu tarjeta debitaremos $10 pesos, que se reintegrarán automáticamente.
          <br/>El pago se realizará según lo acordado con tu Guru Asesor.
        </Typography>
      </div>
      <Grid container spacing={16}>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={8}>
            <Grid item xs={12} style={{paddingTop: 25, paddingBottom: 8}}>
              <CardNumberInput onChange={onNumberChange} autoFocus={true}/>
            </Grid>
            <Grid item xs={12}>
              <CardExpiryInput inputStyle={{width: '100%'}} onChange={onExpiryChange} margin="dense"/>
            </Grid>
            <Grid item xs={12}>
              <CardCVCInput inputStyle={{width: '100%'}} onChange={props.setCardCVC} margin="dense" type={props.type}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <CardholderNameInput onChange={props.setCardholderName} margin="dense"/>
            </Grid>
            <Grid item xs={12}>
              <DocumentTypeSelector onChange={props.setDocumentType} margin="dense" options={options}/>
            </Grid>
            <Grid item xs={12}>
              <DocumentNumberInput onChange={props.setDocumentNumber} margin="dense"/>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.bottomContainer}>
        <Grid item xs={12}>
          <Typography color="error" align="center">{props.error}</Typography>
        </Grid>
      </Grid>
      <div className={classes.navigator}>
        <Button
          variant='primary'
          onClick={onBuy}
          disabled={
            loadingCard ||
            props.number === '' ||
            props.expiry === '' ||
            props.cvc === '' ||
            props.cardholderName === '' ||
            documentType === '' ||
            documentNumber === '' ||
            props.type === '' ||
            isDocNumberInvalid()
          }
        >
          Confirmar
          {loadingCard && <CircularProgress size={24} className={classes.buttonProgress}/>}
        </Button>
      </div>
      <Typography className={classes.mpLabel} variant='body1' align='center'>
        Los datos son procesados de manera segura con
        <img src="/assets/mp.png" alt="mercado pago" width={100} className={classes.mp}/>
      </Typography>
    </Fragment>
  )
}

export default withStyles(styles, {withTheme: true})(CreditCardForm)



// WEBPACK FOOTER //
// ./src/sections/addCreditCard/components/CreditCardForm.js